import { useEffect } from 'react';
import { hasFunctionalConsent, CONSENT_CHANGED_EVENT } from './CookieConsent';

const SCRIPT_MARKER = 'data-eddp-bugherd';

/**
 * Loads BugHerd sidebar on every route when REACT_APP_BUGHERD_API_KEY is set
 * AND the user has granted functional cookie consent (see CookieConsent.js).
 * Third-party script injection without consent is a PECR/GDPR violation, so
 * this waits for the consent-changed event when no decision exists yet.
 * @see https://www.bugherd.com/
 */
export default function BugHerdScript() {
  useEffect(() => {
    const apiKey = process.env.REACT_APP_BUGHERD_API_KEY;
    if (!apiKey) return undefined;

    const inject = () => {
      try {
        if (document.querySelector(`script[${SCRIPT_MARKER}]`)) return;

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = `https://www.bugherd.com/sidebarv2.js?apikey=${encodeURIComponent(apiKey)}`;
        script.setAttribute(SCRIPT_MARKER, 'true');
        document.body.appendChild(script);
      } catch (err) {
        console.error('BugHerd: failed to inject script', err);
      }
    };

    if (hasFunctionalConsent()) {
      inject();
      return undefined;
    }

    const onConsentChanged = (event) => {
      if (event?.detail?.functional === true) inject();
    };
    window.addEventListener(CONSENT_CHANGED_EVENT, onConsentChanged);
    return () => window.removeEventListener(CONSENT_CHANGED_EVENT, onConsentChanged);
  }, []);

  return null;
}
